import { handleActions } from 'redux-actions';
import cloneDeep from 'lodash/cloneDeep';

import http from '../shared/http';
import intl from '../shared/intl';
import endpoints from '../../config/endpoints';

const DATA_FETCH_SUCCESS = 'smart-notification/data-fetch-success';
const DATA_FETCH_ERROR  = 'smart-notification/data-fetch-error';
const SET_SPLIT_SUCCESS = 'smart-notification/set-split-success';
const SET_SPLIT_ERROR = 'smart-notification/set-split-error';
const CLOSE_POPUP = 'smart-notification/close-popup';

// initialState state
const initialState = {
	data: {},
	error: false
};

// actions
export const actions = {
	fetchData: () => (dispatch, getState) => {
		const state = getState();
		if (state.app.userData.general.is_from_admin) {
			return;
		}
		const request = http({
			url: endpoints.SMART_NOTIFICATIONS.POP,
			method: 'get',
			actions: [
				DATA_FETCH_SUCCESS,
				DATA_FETCH_ERROR
			]
		});
		request(dispatch);
	},
	activateSplit: event_id => (dispatch, getState) => {
		const request = http({
			url: `${endpoints.STREAMS.LIST}/smart-split`,
			method: 'post',
			data: {
				event_id
			},
			actions: [
				SET_SPLIT_SUCCESS,
				SET_SPLIT_ERROR
			]
		});
		request(dispatch);
		actions.closePopup()(dispatch, getState);
	},
	closePopup: () => (dispatch, getState) => {
		dispatch({type: CLOSE_POPUP});
		setTimeout(() => {
			actions.fetchData()(dispatch, getState);
		}, 6 * 60 * 1000);
	}
};

// reducers
export default handleActions({
	[DATA_FETCH_SUCCESS]: (state, action) => {
		if (!action.payload.data) { //overcome default renderer `null` data logic
			action.payload.data = {};
		}
		return {
			...state,
			data: action.payload.data
		};
	},
	[DATA_FETCH_ERROR]: state => {
		return { ...state, error: true };
	},
	[CLOSE_POPUP]: state => {
		return { ...state, data: {} };
	}
}, cloneDeep(initialState));

// selectors
export const selectors = {
	getData: state => state.smartNotification.data,
	getIntl: state => intl(state)
};



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/smart-notification/index.js